export const RELEASE_NOTES = [
    {
        date: "2026-10-31",
        highlights: [
            {
                "en-US": "See and log your loads in pounds, if you prefer, in Profile.",
                "pt-BR": "Veja e registre as cargas em libras, se preferir, no Perfil.",
            },
            {
                "en-US": "The app now speaks Spanish, European Portuguese, French, German and Italian.",
                "pt-BR": "O app agora fala espanhol, português de Portugal, francês, alemão e italiano.",
            },
            {
                "en-US": "Trainers can invite students, assign plans, see their workouts and chat with them.",
                "pt-BR": "Personais podem convidar alunos, atribuir planos, ver os treinos e conversar com eles.",
            },
            {
                "en-US": "Clubs: train with friends in rounds of challenges, with reactions and a short chat.",
                "pt-BR": "Clubes: treine com amigos em rodadas de desafios, com reações e um chat curto.",
            },
            {
                "en-US": "Share your plan with a code, browse the plan gallery and the community board, and invite friends.",
                "pt-BR": "Compartilhe o seu plano por código, veja a galeria de planos e o mural da comunidade, e convide amigos.",
            },
            {
                "en-US": "With the new app version: home-screen widgets, the rest countdown on the lock screen and your watch, and Health Connect.",
                "pt-BR": "Com a versão nova do app: widgets na tela inicial, a contagem do descanso na tela bloqueada e no relógio, e o Health Connect.",
            },
        ],
        version: "2.22.0",
    },
    {
        date: "2026-10-31",
        highlights: [
            {
                "en-US": "Share your records, your streak, your milestones and your month as ready-made story images.",
                "pt-BR": "Compartilhe seus recordes, sua sequência, seus marcos e o seu mês como imagens prontas para os stories.",
            },
            {
                "en-US": "Your recap can now be shared as a short video, made right on your phone.",
                "pt-BR": "A Retrospectiva agora pode ser compartilhada como um vídeo curto, feito no próprio celular.",
            },
            {
                "en-US": "Try the app first: answer the questions, and your e-mail is asked only at the end.",
                "pt-BR": "Experimente antes: responda às perguntas, e o e-mail só é pedido no fim.",
            },
            {
                "en-US": "News, a list of what is coming next with your vote, and a box to suggest a feature, all in your profile.",
                "pt-BR": "Novidades, a lista do que vem por aí com o seu voto e uma caixa para sugerir funções, tudo no seu perfil.",
            },
        ],
        version: "2.21.0",
    },
    {
        date: "2026-10-24",
        highlights: [
            {
                "en-US": "The workout summary compares with the last time you trained the same plan day.",
                "pt-BR": "O resumo do treino compara com a última vez que você fez o mesmo treino do plano.",
            },
            {
                "en-US": "Add an exercise to the workout in progress; at the end, the app asks whether it joins your plan.",
                "pt-BR": "Adicione um exercício ao treino em andamento; no fim, o app pergunta se ele entra no plano.",
            },
            {
                "en-US": "Blank workout: start with no plan and pick the exercises as you go.",
                "pt-BR": "Treino em branco: comece sem plano e escolha os exercícios pelo caminho.",
            },
            {
                "en-US": "Load progression follows the right week of your plan, so the deload arrives on time.",
                "pt-BR": "A progressão das cargas segue a semana certa do plano, e o deload chega na hora certa.",
            },
        ],
        version: "2.20.0",
    },
    {
        date: "2026-10-17",
        highlights: [
            {
                "en-US": "A new record is celebrated the moment you log the set, with a sound.",
                "pt-BR": "Um recorde novo é comemorado na hora em que você registra a série, com som.",
            },
            {
                "en-US": "Supersets: exercises done back to back in rounds, with the rest after the round.",
                "pt-BR": "Supersets: exercícios em sequência, em rodadas, com o descanso depois da rodada.",
            },
            {
                "en-US": "Quick workout: say how many minutes you have and get a workout for today.",
                "pt-BR": "Treino rápido: diga quantos minutos você tem e receba um treino para hoje.",
            },
            {
                "en-US": "A weekly and a monthly report, on the Progress tab.",
                "pt-BR": "Relatório semanal e mensal, na aba Progresso.",
            },
            {
                "en-US": "Pause the workout clock, and the app asks about a workout left open.",
                "pt-BR": "Pause o cronômetro do treino, e o app pergunta sobre um treino que ficou aberto.",
            },
            {
                "en-US": "At the end of a workout, update your plan with today's numbers, one change at a time.",
                "pt-BR": "No fim do treino, atualize o plano com os valores de hoje, uma mudança de cada vez.",
            },
            {
                "en-US": "Your plan names the phase you are in and tells you when it is a deload week.",
                "pt-BR": "O plano diz em que fase você está e avisa quando é semana de deload.",
            },
            {
                "en-US": "Body photos: the app says which photo to retake and why, and checks your pose before it shoots.",
                "pt-BR": "Fotos do corpo: o app diz qual foto refazer e por quê, e confere a pose antes de fotografar.",
            },
        ],
        version: "2.19.0",
    },
];
//# sourceMappingURL=release-notes.js.map